import { LocaleId, TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n';
import { RegistrationDataAccessTranslationDictionary } from './registration-data-access-dictionary.interface';

export const translation: TranslationDictionaryMapping<RegistrationDataAccessTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      REGISTRATION_DATA_ACCESS_REGISTERING_NOTIFICATION:
        'Registration is loading, please wait',
    },
    [LocaleId.English_Ireland]: {
      REGISTRATION_DATA_ACCESS_REGISTERING_NOTIFICATION:
        'Registration is loading, please wait',
    },
    [LocaleId.English_US]: {
      REGISTRATION_DATA_ACCESS_REGISTERING_NOTIFICATION:
        'Registration is loading, please wait',
    },
  };
